import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  CdsInputsModule,
  CDS_PAGINATION_RENDERER_HOST,
  CdsPaginationRendererHost,
} from '@celerofinancas/design-system';

/**
 * Custom renderer for `cds-pagination` that matches the Figma footer
 * ("Itens por página: [10] · 1 - 10 de 40 · |< < Página X de Y > >|").
 *
 * It reuses the pagination LOGIC/state from the host (injected via
 * CDS_PAGINATION_RENDERER_HOST) and only replaces the rendering. Provided to
 * cds-pagination through the CDS_PAGINATION_RENDERER token.
 */
@Component({
  selector: 'caixa-webcomponent-credit-card-pagination-renderer',
  standalone: true,
  templateUrl: './credit-card-pagination-renderer.component.html',
  styleUrl: './credit-card-pagination-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, CdsInputsModule],
})
export class CreditCardPaginationRendererComponent {
  /**
   * Pagination host contract (state + actions), provided by cds-pagination.
   */
  protected readonly host = inject<CdsPaginationRendererHost>(CDS_PAGINATION_RENDERER_HOST);

  /**
   * Drives the page-size dropdown selection; seeded from the host's current
   * offset and pushed back through the host on change.
   */
  protected readonly pageSizeControl = new FormControl(this.host.selectedOffset);

  /**
   * Handles page-size selection.
   *
   * @param size new page size
   */
  protected onPageSize(size: number): void {
    this.host.changePageSize(size);
  }
}
